export const brandAssets = {
  logo: '/brand/logo.png',
  logoDark: '/brand/logo-dark.png',
  mark: '/brand/mark.png',
  favicon: '/favicon.ico',
  appleIcon: '/brand/apple-icon.png',
} as const
